import { Controller } from "@hotwired/stimulus";

// Handles card-based selection for core competencies on talent profile forms.
export default class extends Controller {
  static targets = ["card", "checkbox", "indicator", "counter", "warning"];
  static values = { maxSelected: Number };

  connect() {
    this.updateUI();
  }

  toggle(event) {
    const checkbox = event.currentTarget;

    if (checkbox.checked && this.checkedCount() > this.maxAllowed()) {
      checkbox.checked = false;
      this.showWarning();
      this.updateUI();
      return;
    }

    this.hideWarning();
    this.updateUI();
  }

  updateUI() {
    this.cardTargets.forEach((card, index) => {
      const checkbox = this.checkboxTargets[index];
      if (!checkbox) return;

      const indicator = this.indicatorTargets[index];
      const checked = checkbox.checked;
      const selectedClasses = this.selectedClasses(card);
      const unselectedClasses = this.unselectedClasses(card);

      selectedClasses.forEach((klass) => {
        if (klass.length === 0) return;
        card.classList.toggle(klass, checked);
      });

      unselectedClasses.forEach((klass) => {
        if (klass.length === 0) return;
        card.classList.toggle(klass, !checked);
      });

      if (indicator) {
        indicator.classList.toggle("opacity-0", !checked);
      }
    });

    this.updateCounter();
  }

  updateCounter() {
    if (!this.hasCounterTarget) return;
    const count = this.checkedCount();
    this.counterTarget.textContent = `Selected ${count} / ${this.maxAllowed()}`;
  }

  checkedCount() {
    return this.checkboxTargets.filter((checkbox) => checkbox.checked).length;
  }

  maxAllowed() {
    return this.hasMaxSelectedValue ? this.maxSelectedValue : 4;
  }

  showWarning() {
    if (!this.hasWarningTarget) return;
    this.warningTarget.classList.remove("hidden");
  }

  hideWarning() {
    if (!this.hasWarningTarget) return;
    this.warningTarget.classList.add("hidden");
  }

  selectedClasses(card) {
    return (card.dataset.coreCompetenciesSelectedClass || "")
      .split(" ")
      .filter(Boolean);
  }

  unselectedClasses(card) {
    return (card.dataset.coreCompetenciesUnselectedClass || "")
      .split(" ")
      .filter(Boolean);
  }
}
